import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';

export const Wrapper = styled.div`
  background-color: ${themeGet('colors.neutral_1')};
`;

export const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  padding: 50px 0 60px;
  max-width: 857px;

  // * Title
  h1:first-child,
  h2:first-child,
  h3:first-child,
  h4:first-child,
  h5:first-child,
  h6:first-child {
    color: ${themeGet('colors.text-secondary')};
    text-align: center;
    margin-bottom: 20px;

    font-size: 26px;
    line-height: 34px;
  }

  // * Subtitle
  h1:nth-child(2n),
  h2:nth-child(2n),
  h3:nth-child(2n),
  h4:nth-child(2n),
  h5:nth-child(2n),
  h6:nth-child(2n) {
    font-weight: ${themeGet('font-weights.bold')};
    text-align: center;

    font-size: 20px;
    line-height: 26px;
  }

  @media only screen and (min-width: ${themeGet('breakpoint.xs')}) {
    padding: 50px 0 60px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 76px 45px 90px;

    h1:first-child,
    h2:first-child,
    h3:first-child,
    h4:first-child,
    h5:first-child,
    h6:first-child {
      font-size: 36px;
      line-height: 46px;
    }

    h1:nth-child(2n),
    h2:nth-child(2n),
    h3:nth-child(2n),
    h4:nth-child(2n),
    h5:nth-child(2n),
    h6:nth-child(2n) {
      font-size: 22px;
      line-height: 32px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    h1:first-child,
    h2:first-child,
    h3:first-child,
    h4:first-child,
    h5:first-child,
    h6:first-child {
      margin-bottom: 20px;
    }

    padding: 70px 0 90px;
  }
`;

export const Content = styled.ul`
  && {
    padding-top: 54px;
    margin: -45px 0;
  }

  li {
    margin: 45px 0;

    p {
      font-size: 14px;
      line-height: 22px;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        font-size: 18px;
        line-height: 30px;
      }
    }

    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      margin: 36px 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    && {
      padding-top: 40px;
    }
  }
`;

export const ListItem = styled.div`
  display: flex;
  align-items: flex-start;

  &::before {
    content: '';
    background-image: url(${({ image }) => image});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    height: 36px;
    min-width: 36px;
    margin-right: 13px;

    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      height: 27px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    align-items: center;
    &::before {
      margin-right: 32px;
    }
  }
`;
